module.exports = __webpack_public_path__ + "static/media/home.e3d435ec.svg";